export default{
    state: {
        status: {
            boxAlert: false,
            isLoad: false
        },
        ifLoged: true,
        userAccount:{
            name: '',
            company: '',
            email: '',
            timezome: '',
            type: '',
            credit: '',
            user: '',
            account: ''
        },
    },
    getters: {
        status:(state) => state.status,
        ifLoged: (state) => state.ifLoged,
        userAccount: (state) => state.userAccount
    },
    mutations: {
        loading: (state) => state.status.isLoad = true,
        status_success:(state, data) => {
            state.status.boxAlert = data
        },
        status_invalid:(state, data) => {
            state.status.isLoad = data.success
            state.status.boxAlert = !data.success
        },
        logIn:(state)=> {
            state.ifLoged = true
        },
        isLogOut: (state)=>{
            localStorage.removeItem('enableAutoTestPopup');
            localStorage.removeItem('userToken')
            localStorage.removeItem('account')
            localStorage.removeItem('user')
            state.ifLoged = false
            // location.reload()
        },
        isLogin: (state) => {
            const verifyToken = localStorage.getItem('userToken')
            if (verifyToken) {
                state.ifLoged = true;
            } else {
                state.ifLoged = false;

            }
        },
        UserAccount: (state) => {
            state.userAccount.name = JSON.parse(window.localStorage.getItem('user')).name
            state.userAccount.user = JSON.parse(window.localStorage.getItem('user'))
            state.userAccount.account = JSON.parse(window.localStorage.getItem('account'))
            state.userAccount.company = JSON.parse(window.localStorage.getItem('account')).name
            state.userAccount.email =  JSON.parse(window.localStorage.getItem('user')).email
            state.userAccount.timezome =  JSON.parse(window.localStorage.getItem('account')).timezone
            state.userAccount.type = JSON.parse(window.localStorage.getItem('account')).type
            state.userAccount.credit = JSON.parse(window.localStorage.getItem('credit'))
        }
    }
}